export default "__VITE_ASSET__BwSrLu0H__"